import { __awaiter, __generator } from "tslib";
import { addDays, getCurrentDate } from '@office-start/date-utility';
import { buildUserStorageOptions, getUsedThirdPartyAppsUserData, setUsedThirdPartyAppsUserData, } from './usedThirdPartyAppsUtils';
export function cleanUnusedThirdPartyWorkloads(componentContext) {
    return __awaiter(this, void 0, void 0, function () {
        var userStorageOptions, usedThirdPartyWorkloads, clickWindowStart, oldWorkloadsLength;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!componentContext) {
                        return [2 /*return*/];
                    }
                    userStorageOptions = buildUserStorageOptions(componentContext);
                    return [4 /*yield*/, getUsedThirdPartyAppsUserData(userStorageOptions)];
                case 1:
                    usedThirdPartyWorkloads = (_a.sent()) || [];
                    if (usedThirdPartyWorkloads.length === 0) {
                        return [2 /*return*/];
                    }
                    clickWindowStart = addDays(getCurrentDate(), -45).getTime();
                    oldWorkloadsLength = usedThirdPartyWorkloads.length;
                    usedThirdPartyWorkloads = usedThirdPartyWorkloads.filter(function (workload) { return workload.LastOccurrence >= clickWindowStart; });
                    if (oldWorkloadsLength !== usedThirdPartyWorkloads.length) {
                        setUsedThirdPartyAppsUserData(usedThirdPartyWorkloads, buildUserStorageOptions(componentContext));
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=cleanUnusedThirdPartyWorkloads.js.map